export default __webpack_public_path__ + "static/media/HImachal.75c1943c.png";